// extracted by mini-css-extract-plugin
module.exports = {"author":"c1_q9","author__avatar":"c1_rb","author__img":"c1_rc","author__text":"c1_rd"};